// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    [
      {
        "sub": "Python语言及应用",
        "tec": "单中元",
        "week": "1-12周",
        "add": "教学楼C座405管理"
      },
      {
        "sub": "劳动与创造",
        "tec": "刘焕焕",
        "week": "13周",
        "add": "教学楼C座403管理"
      }
    ],
    [
      {
        "sub": "云计算原理与应用",
        "tec": "杨弘平",
        "week": "2-12周",
        "add": "教学楼C座402管理"
      },
      {
        "sub": "劳动与创造",
        "tec": "刘焕焕",
        "week": "13周",
        "add": "教学楼C座403管理"
      }
    ],
    {
      "sub": "操作系统原理",
      "tec": "才九荣",
      "week": "1-12周",
      "add": "实训楼F座302信息"
    },
    0,
    0
  ],
  "2": [
    {
      "sub": "就业创业指导",
      "tec": "刘焕焕",
      "week": "2-6周",
      "add": "教学楼C座403管理"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "周彩虹",
        "week": "1-5,7-9周",
        "add": "教学楼A座325电力"
      },
      {
        "sub": "国家安全教育",
        "tec": "周彩虹",
        "week": "10-13周",
        "add": "教学楼A座325电力"
      }
    ],
    {
      "sub": "Hadoop 大数据技术",
      "tec": "夏炎",
      "week": "2-13周",
      "add": "实训楼F座507信机"
    },
    {
      "sub": "Hadoop 大数据技术",
      "tec": "夏炎",
      "week": "2-13周",
      "add": "实训楼F座507信机"
    },
    0
  ],
  "3": [
    [
      {
        "sub": "算法竞赛",
        "tec": "周强",
        "week": "1-8周",
        "add": "教学楼C座402管理"
      },
      {
        "sub": "劳动与创造",
        "tec": "刘焕焕",
        "week": "13周",
        "add": "教学楼C座403管理"
      }
    ],
    {
      "sub": "劳动与创造",
      "tec": "刘焕焕",
      "week": "13周",
      "add": "教学楼C座403管理"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "Python语言及应用",
      "tec": "单中元",
      "week": "1-12周",
      "add": "教学楼C座403管理"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "周彩虹",
        "week": "1-5,7-9周",
        "add": "教学楼A座326电力"
      },
      {
        "sub": "国家安全教育",
        "tec": "周彩虹",
        "week": "10-13周",
        "add": "教学楼A座326电力"
      }
    ],
    0,
    0,
    0
  ],
  "5": [
    {
      "sub": "云计算原理与应用",
      "tec": "杨弘平",
      "week": "2-12单周",
      "add": "教学楼C座402管理"
    },
    {
      "sub": "操作系统原理",
      "tec": "才九荣",
      "week": "1-12周",
      "add": "实训楼F座302信息"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
